import { createContext, useContext, useMemo, useState, type Dispatch, type ReactNode, type SetStateAction } from 'react';

export interface HeaderActionsState {
  compareCount: number;
  onCompare?: () => void;
  onDownload?: () => void;
  onContactSales?: () => void;
  onLogoClick?: () => void;
}

export const DEFAULT_HEADER_ACTIONS: HeaderActionsState = {
  compareCount: 0,
};

interface HeaderActionsContextValue {
  headerActions: HeaderActionsState;
  setHeaderActions: Dispatch<SetStateAction<HeaderActionsState>>;
}

const HeaderActionsContext = createContext<HeaderActionsContextValue>({
  headerActions: DEFAULT_HEADER_ACTIONS,
  setHeaderActions: () => undefined,
});

interface HeaderActionsProviderProps {
  children: ReactNode;
}

export const HeaderActionsProvider = ({ children }: HeaderActionsProviderProps) => {
  const [headerActions, setHeaderActions] = useState<HeaderActionsState>(DEFAULT_HEADER_ACTIONS);

  const value = useMemo(
    () => ({ headerActions, setHeaderActions }),
    [headerActions]
  );

  return <HeaderActionsContext.Provider value={value}>{children}</HeaderActionsContext.Provider>;
};

export const useHeaderActions = () => useContext(HeaderActionsContext);
